import api from "../index";
// import * as _helper from '../helper';
import * as URL from "../url";


export const RoleList = async (params = {}) => {
  try {
    const response = await api.get(URL.USERROLE, { params });
    console.log("response RolesLists** ", response);
    return response;
  } catch (error) {
    // _helper.sendResponse('error', error.message)
    console.log(error, "<<");
    return;
  }
};